import { createAction, props } from '@ngrx/store';

import { TenantDtoStoreModel } from '@domain/tenant/tenant.models';

export const synchroniseTenantsCache = createAction(
  '[Tenants cache] synchronise',
  props<{ tenants: TenantDtoStoreModel[] | undefined; isLoading: boolean; error: string | undefined }>()
);
